module.exports = __webpack_public_path__ + "static/media/tarjeta-bloqueada.8e3beaf0.svg";